import React, { useEffect } from "react";
import { Container, Link, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { TargetOrderStyles } from "../styles/TargetOrder.style";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import usePermission from "src/utils/hooks/usePermission";
import BrokerUnassigned from "src/icons/BrokerUnassigned";
import { trackEvent } from "src/Amplitude";
import { useUserSlice } from "src/store/features/user.slice";

const TargetOrderBrokerMessageHeader = () => {
  // --------------------------REDUX----------------
  const classes = TargetOrderStyles();
  const {
    details: { name: USER_NAME },
    broker: { name: brokerName, imgUrl: BROKER_IMG },
  } = useUserSlice();
  // --------------------------STYLES----------------
  const theme = useTheme();

  // --------------------------CONST----------------
  const { userPermission } = usePermission();
  const isGuest = userPermission === "guest" || userPermission === "";
  const BROKER_NAME = isGuest
    ? "Broker Unassigned"
    : `Your Broker, ${brokerName.split(" ").slice(0, -1)}`;
  const BROKER_MESSAGE = `Hi ${
    USER_NAME || ""
  }, please enter your details below to place a target. ${
    USER_NAME.length < 10 ? "If you have any questions, feel free to contact me!" : ""
  }` as const;

  useEffect(() => {
    if (isGuest) trackEvent("Guest Viewed Target Orders Broker Unnasignned Component");
  }, []);
  return (
    <div className={classes.headerContainer}>
      <Container sx={{ padding: "32px 24px 24px 24px" }}>
        <Typography
          sx={{
            fontSize: "14px",
            lineHeight: "17px",
            fontWeight: 600,
          }}>
          {BROKER_MESSAGE}
        </Typography>
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Link
            sx={{
              alignSelf: "end",
              color: "#fff",
              height: "20px",
            }}
            href="https://support.calebandbrown.com/en/articles/11182116-how-to-place-a-target-order-limit-order"
            rel="noreferrer"
            target="_blank">
            <HelpOutlineIcon sx={{ height: "20px", width: "20px" }} />
          </Link>
          <Stack direction="row" spacing={1}>
            <Typography
              sx={{
                color: theme.palette.secondary.main,
                alignSelf: "end",
                fontWeight: 600,
              }}>
              {BROKER_NAME}
            </Typography>
            {!BROKER_IMG && !isGuest && (
              <Skeleton
                variant="circular"
                width={"40px"}
                height={"40px"}
                sx={{ backgroundColor: "gray" }}
              />
            )}
            {userPermission !== "guest" && BROKER_IMG && (
              <img
                alt="broker avatar"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50% ",
                  border: `1px solid ${theme.palette.secondary.main}`,
                }}
                src={BROKER_IMG}
              />
            )}
            <Stack>
              {userPermission === "guest" && <BrokerUnassigned width={"40px"} height={"40px"} />}
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </div>
  );
};

export default TargetOrderBrokerMessageHeader;
